import React from 'react';
// @ts-expect-error: allow JS import
import Link from '../../Link/Link';

type LabelLink = {
  url: string;
  copy: string;
};

// @deprecated
// Use renderLink in form.styles.tsx
export const renderLabelLink = (
  screenSize: string,
  labelLink?: LabelLink | React.ReactNode
): React.ReactNode | null => {
  if (labelLink) {
    const labelLinkClass = screenSize === 'desktop' ? 'label__link-desktop' : 'label__link-mobile';

    // PropTypes.node
    if (React.isValidElement(labelLink)) {
      return <span className={labelLinkClass}>{labelLink}</span>;
    }

    const { url, copy } = labelLink as LabelLink;
    return (
      <span className={labelLinkClass}>
        <Link href={url} arrow size="small">
          {copy}
        </Link>
      </span>
    );
  }
  return null;
};

// @deprecatd
// use functions in showMessageType
export const calculateNotificationStyle = (
  notificationType: string,
  totalLimit: number,
  inputLength: number,
  warningLimit?: number,
  minCount?: number
): boolean => {
  switch (notificationType) {
    case 'warning':
      if (warningLimit && totalLimit && inputLength) {
        return inputLength > totalLimit - warningLimit && inputLength <= totalLimit;
      }
      return false;
    case 'min_invalid':
      return minCount ? inputLength < minCount : false;
    case 'max_invalid':
      return totalLimit && inputLength ? inputLength > totalLimit : false;
    default:
      return false;
  }
};
